import { ReactElement } from 'react';
import { useNavigate, useRouter } from '@tanstack/react-router';
import LockUp from '../assets/brand/lock-up.svg';
import { Button } from '@sc/shared-ui';
import {
  ArrowLeftIcon,
  MagnifyingGlassIcon,
} from '@heroicons/react/24/outline';

export const NotFound = (): ReactElement => {
  const navigate = useNavigate();
  const router = useRouter();

  return (
    <div className="bg-background-secondary h-full w-full">
      <div className="h-full px-15 p-8 flex items-center flex-col">
        <LockUp className="w-40" />
        <div className="grow flex flex-col justify-center w-88">
          <div className="space-y-5 text-center flex flex-col">
            <div className="rounded-full mx-auto border border-secondary-300 w-fit p-6">
              <MagnifyingGlassIcon className="size-11 stroke-secondary-300" />
            </div>
            <h1 className="font-grotesque text-h1-display font-bold text-center">
              404
            </h1>
            <h2 className="font-grotesque text-h2 font-medium text-center">
              Page not found
            </h2>
            <p className="text-body-medium text-text-low-priority">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <div className="mt-5 space-y-3">
              <Button
                button={{
                  type: 'primary',
                  text: 'Go to dashboard',
                  size: 'large',
                  onClick: () =>
                    void navigate({
                      to: '/',
                    }),
                }}
              />
              <Button
                button={{
                  type: 'basic',
                  text: 'Go back',
                  size: 'large',
                  IconStart: ArrowLeftIcon,
                  onClick: () => router.history.back(),
                }}
              />
            </div>
          </div>
        </div>
        <div className="space-y-2 w-full max-w-88">
          <p>
            If you think this is a mistake, please contact{' '}
            <a
              className="underline text-primary-400"
              href="mailto:support@starkchat.com"
            >
              Tech support
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};
